import { router } from "expo-router"

type ReplacementHref = Parameters<typeof router.replace>[0]

export function backOrReplace(fallbackHref: ReplacementHref) {
  if (router.canGoBack()) {
    router.back()
    return
  }

  router.replace(fallbackHref)
}
